import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

const Our_Category = () => {
  const [categories, setCategories] = useState([]);

  useEffect(() => {
    fetch('https://www.hum.ujn.mybluehostin.me/new_clinet/snkb_api/category.php')
      .then(response => response.json())
      .then(data => setCategories(data))
      .catch(error => console.error('Error fetching data:', error));
  }, []);

  return (
    <div>
      {/* Page Title Section */}
      <section className="page-title centred">
        <div className="bg-layer" style={{ backgroundImage: 'url(/assets/img/bg-img.png)' }}></div>
        <div className="line-box">
          <div className="line-1"></div>
          <div className="line-2"></div>
        </div>
        <div className="auto-container">
          <div className="content-box">
            <h1>Category</h1>
            <ul className="bread-crumb clearfix">
              <li><Link  to ="/">Home</Link></li>
              <li>Category</li>
            </ul>
          </div>
        </div>
      </section>

      {/* Blog Grid Section */}
      <section className="blog-grid">
        <div className="auto-container">
          <div className="sec-title centred">
            <span className="sub-title">Our Category</span>
            <h2>Wide Range Of Bearings</h2>
          </div>
          <div className="row clearfix">
            {categories.map(category => (
              <div key={category.id} className="col-lg-4 col-md-6 col-sm-12 news-block">
                <div className="news-block-one">
                  <div className="inner-box" style={{ height: '382px' }}>
                    <Link  to ={`/Products?category=${category.id}&cname=${encodeURIComponent(category.name)}`}>
                      <div className="image-box">
                        <figure className=""><img src={`/assets/img/${category.img}`} alt={category.name} /></figure>
                        <div className="category">
                          <Link to={`/Products?category=${category.id}`}>
                            {category.name}
                          </Link>
                        </div>
                      </div>
                    </Link>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};



export default Our_Category
